import RouteMap from "./RouteMap";
import { formatArrival, bareDuration, pickupLabel } from "./utils";

// Chrome 60-safe — no ?. / flex gap / backdrop-filter
const LandscapeEta = function (props) {
  var s = props.s;
  var pickup = props.pickup;
  var routes = props.routes;
  var error = props.error;
  var single = props.single;
  var onMapLoad = props.onMapLoad;
  var showMap = props.showMap !== false;
  var pickLabel = function (r) {
    if (!r) return "";
    return !showMap && r.fullLabel ? r.fullLabel : r.label;
  };
  var r0 = routes[0];
  var stackGap = s.dotLive.width;
  // map-mode cards, sized against the side panel rather than the whole screen
  var mc = s.nmCards(1, routes.length, s.mapPanelBox.landscape);

  // With no map to share the screen with, the panel becomes the whole widget:
  // an editorial two-column read rather than a stretched side panel.
  if (!showMap) {
    var badge = (
      <span style={s.nmBadge}>
        <span style={s.nmDot} /> Live Traffic ETA
      </span>
    );

    // pickup shown once for the whole list, not repeated per card

    var from = (
      <span style={s.nmFrom}>
        <span style={s.nmFromLabel}>From</span>
        <span style={s.nmFromValue}>{pickupLabel(pickup) || "—"}</span>
      </span>
    );

    if (error) {
      return (
        <div style={s.nmRoot}>
          <div style={s.nmGlow} />
          <div style={s.nmGlowLow} />
          <div style={s.nmTopBar}>{badge}</div>
          <div
            style={Object.assign({}, s.nmBody, {
              justifyContent: "center",
              alignItems: "center",
            })}
          >
            <div style={s.nmError}>{error}</div>
          </div>
        </div>
      );
    }

    if (single) {
      var arrival = formatArrival(r0 && r0.durationSecs);
      return (
        <div style={s.nmRoot}>
          <div style={s.nmGlow} />
          <div style={s.nmGlowLow} />
          <div style={s.nmTopBar}>
            {badge}
            {r0 && r0.traffic ? (
              <span
                style={Object.assign({}, s.nmPill, { color: r0.traffic.color })}
              >
                <span style={s.nmPillDot} />
                {r0.traffic.label}
              </span>
            ) : null}
          </div>

          <div
            style={Object.assign({}, s.nmBody, {
              flexDirection: "row",
              alignItems: "center",
            })}
          >
            <div
              style={{
                flex: 1.05,
                minWidth: 0,
                paddingRight: s.nmRail.marginRight,
              }}
            >
              <div style={s.nmJourney}>
                <div style={s.nmRail}>
                  <span style={s.nmRailDot} />
                  <span style={s.nmRailLine} />
                  <span style={s.nmRailPin} />
                </div>
                <div style={s.nmStops}>
                  <div style={s.nmStopLabel}>From</div>
                  <div style={s.nmStopValue}>{pickupLabel(pickup) || "—"}</div>
                  <div style={s.nmStopGap} />
                  <div style={s.nmStopLabel}>To</div>
                  <div style={s.nmStopValue}>{pickLabel(r0)}</div>
                </div>
              </div>
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={s.nmHeroLabel}>Estimated time</div>
              <div style={s.nmHeroRow}>
                <span style={s.nmHeroValue}>
                  {(r0 && bareDuration(r0.duration)) || "--"}
                </span>
              </div>
              <div
                style={Object.assign({}, s.nmStats, {
                  marginTop: s.nmStopGap.height,
                })}
              >
                <div style={s.nmTile}>
                  <div style={s.nmTileLabel}>Distance</div>
                  <div style={s.nmTileValue}>{(r0 && r0.distance) || "--"}</div>
                </div>
                {arrival ? (
                  <div style={Object.assign({}, s.nmTile, { marginRight: 0 })}>
                    <div style={s.nmTileLabel}>Arrives</div>
                    <div style={s.nmTileValue}>{arrival}</div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      );
    }

    // a pair goes left/right on a wide screen; otherwise one card per row
    var pair = routes.length === 2 && s.nmSideBySidePair;
    var c = pair ? s.nmCards(2, 1) : s.nmCards(1, routes.length);
    return (
      <div style={s.nmRoot}>
        <div style={s.nmGlow} />
        <div style={s.nmGlowLow} />
        <div style={s.nmTopBar}>
          {badge}
          {s.nmFromInline ? from : null}
        </div>
        {s.nmFromInline ? null : <div style={s.nmFromRow}>{from}</div>}
        <div
          style={Object.assign({}, s.nmList, pair ? s.nmListRow : null, {
            flexDirection: pair ? "row" : "column",
          })}
        >
          {routes.map(function (r) {
            return (
              <div
                key={r.index}
                style={Object.assign(
                  {},
                  c.card,
                  c.tint(r.traffic && (r.traffic.fill || r.traffic.color)),
                )}
              >
                <span
                  style={Object.assign({}, c.accent, {
                    background: r.traffic ? c.railTint : r.color,
                  })}
                />
                <div style={c.label}>{r.label || pickLabel(r)}</div>
                <div style={c.row}>
                  <span style={c.time}>{bareDuration(r.duration)}</span>
                  <span style={c.dist}>{r.distance}</span>
                </div>
                <div style={c.foot}>
                  {r.traffic ? (
                    <span
                      style={Object.assign({}, c.pill, {
                        color: r.traffic.color,
                      })}
                    >
                      <span style={c.pillDot} />
                      {r.traffic.label}
                    </span>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div style={Object.assign({}, s.wrapper, { flexDirection: "row" })}>
      {showMap ? (
        <div style={s.mapSide}>
          <RouteMap
            s={s}
            pickup={pickup}
            routes={routes}
            single={single}
            onMapLoad={onMapLoad}
          />
        </div>
      ) : null}

      <div style={s.panel}>
        {error ? (
          <span>
            <div style={s.header}>
              <span style={s.badge}>
                <span style={s.dotLive} /> Live Traffic ETA
              </span>
            </div>
            <div style={s.content}>
              <div style={s.error}>{error}</div>
            </div>
          </span>
        ) : single ? (
          <div
            style={Object.assign({}, s.content, {
              justifyContent: "space-evenly",
            })}
          >
            <span style={s.badge}>
              <span style={s.dotLive} /> Live Traffic ETA
            </span>
            <div
              style={Object.assign({}, s.to, {
                marginTop: 0,
                fontSize: parseFloat(s.mins.fontSize) * 1.3 + "px",
              })}
            >
              To: {pickLabel(r0)}
            </div>
            <div
              style={{
                marginTop: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span
                style={Object.assign({}, s.mins, {
                  marginTop: 0,
                  marginBottom: stackGap,
                  fontSize: parseFloat(s.mins.fontSize) * 1.3 + "px",
                  fontWeight: 800,
                })}
              >
                {r0 && r0.duration ? "in " + r0.duration + "." : " "}
              </span>
              {r0 && r0.traffic ? (
                <span
                  style={Object.assign({}, s.trafficPill, { marginTop: 0 })}
                >
                  {r0.traffic.label}
                </span>
              ) : null}
            </div>
            <div
              style={Object.assign({}, s.distance, {
                marginTop: 0,
                fontSize:
                  parseFloat(s.distance.fontSize) *
                    (s.is98 ? 0.84 : 1.2) *
                    0.7 +
                  "px",
              })}
            >
              {(r0 && r0.distance) || "--"}
            </div>
          </div>
        ) : (
          <span>
            <div
              style={Object.assign({}, s.header, {
                justifyContent: "center",
              })}
            >
              <span
                style={Object.assign({}, s.badge, {
                  fontSize: parseFloat(s.badge.fontSize) * 1.3 + "px",
                })}
              >
                <span style={s.dotLive} /> Live Traffic ETA
              </span>
            </div>
            <div
              style={Object.assign({}, s.list, { justifyContent: "center" })}
            >
              {routes.map(function (r) {
                return (
                  <div
                    key={r.index}
                    style={Object.assign(
                      {},
                      mc.card,
                      mc.tint(r.traffic && (r.traffic.fill || r.traffic.color)),
                    )}
                  >
                    <span
                      style={Object.assign({}, mc.accent, {
                        background: r.traffic ? mc.railTint : r.color,
                      })}
                    />
                    <div style={mc.label}>{pickLabel(r)}</div>
                    <div style={mc.row}>
                      <span style={mc.time}>{bareDuration(r.duration)}</span>
                      <span style={mc.dist}>{r.distance}</span>
                    </div>
                    <div style={mc.foot}>
                      {r.traffic ? (
                        <span
                          style={Object.assign({}, mc.pill, {
                            color: r.traffic.color,
                          })}
                        >
                          <span style={mc.pillDot} />
                          {r.traffic.label}
                        </span>
                      ) : null}
                      <span style={mc.routeChip}>
                        A &rarr; {String.fromCharCode(66 + r.index)}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </span>
        )}
      </div>
    </div>
  );
};

export default LandscapeEta;
